import React from 'react';
import PropTypes from 'prop-types';
import { format } from 'date-fns';
import { DATE_FORMAT } from '@cyberint/common-utils';
import * as S from './styled';

export const DateCell = ({ value, renderedCellValue }) => {
  const val = value || renderedCellValue;
  return val ? <S.Cell>{format(new Date(val), DATE_FORMAT.MMM_DD_YYYY)}</S.Cell> : null;
};
DateCell.propTypes = { value: PropTypes.string, renderedCellValue: PropTypes.string };

export const SimpleCell = ({ value, withTitle, withEllipsis, onClick, Icon, disabled, firstColCell }) => (
  <S.Cell
    $withEllipsis={withEllipsis}
    $withIcon={!!Icon}
    $firstColCell={firstColCell}
    title={withTitle && value}
    onClick={onClick}
    disabled={disabled}>
    <span>{value}</span>
    {Icon}
  </S.Cell>
);

SimpleCell.propTypes = {
  value: PropTypes.string,
  withTitle: PropTypes.bool,
  withEllipsis: PropTypes.bool,
  disabled: PropTypes.bool,
  firstColCell: PropTypes.bool,
  onClick: PropTypes.func,
  Icon: PropTypes.element
};
